// extracted by mini-css-extract-plugin
module.exports = {"Layout":"styles_Layout__RAE3r","Footer":"styles_Footer__B_XGR"};